import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';

/**
 * Migration API Service
 */
@Injectable({
    providedIn: 'root'
})
export class MigrationService extends BaseApiService {

    /**
     * Get migration status
     */
    getMigrationStatus(): Observable<any> {
        return this.get<any>('/migration/status')
            .pipe(map(response => response.data!));
    }

    /**
     * Start migration
     */
    startMigration(): Observable<any> {
        return this.post<any>('/migration/start')
            .pipe(map(response => response.data!));
    }

    /**
     * Stop migration
     */
    stopMigration(): Observable<any> {
        return this.post<any>('/migration/stop')
            .pipe(map(response => response.data!));
    }

    /**
     * Get migration progress
     */
    getMigrationProgress(): Observable<any> {
        return this.get<any>('/migration/progress')
            .pipe(map(response => response.data!));
    }

    /**
     * Get migration history
     */
    getMigrationHistory(): Observable<any> {
        return this.get<any>('/migration/history')
            .pipe(map(response => response.data!));
    }

    /**
     * Get migration errors
     */
    getMigrationErrors(): Observable<any> {
        return this.get<any>('/migration/errors')
            .pipe(map(response => response.data!));
    }

    /**
     * Get migration configuration
     */
    getMigrationConfiguration(): Observable<any> {
        return this.get<any>('/migration/configuration')
            .pipe(map(response => response.data!));
    }

    /**
     * Update migration configuration
     */
    updateMigrationConfiguration(config: any): Observable<any> {
        return this.put<any>('/migration/configuration', config)
            .pipe(map(response => response.data!));
    }

    /**
     * Reset migration
     */
    resetMigration(): Observable<any> {
        return this.post<any>('/migration/reset')
            .pipe(map(response => response.data!));
    }
}
